import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
export var ServiceCollection = /*#__PURE__*/function () {
  function ServiceCollection() {
    _classCallCheck(this, ServiceCollection);

    this._entries = new Map();

    for (var _len = arguments.length, entries = new Array(_len), _key = 0; _key < _len; _key++) {
      entries[_key] = arguments[_key];
    }

    for (var _i = 0, _entries = entries; _i < _entries.length; _i++) {
      var _entries$_i = _slicedToArray(_entries[_i], 2),
          id = _entries$_i[0],
          service = _entries$_i[1];

      this.set(id, service);
    }
  }

  _createClass(ServiceCollection, [{
    key: "set",
    value: function set(id, instanceOrDescriptor) {
      var result = this._entries.get(id);

      this._entries.set(id, instanceOrDescriptor);

      return result;
    }
  }, {
    key: "has",
    value: function has(id) {
      return this._entries.has(id);
    }
  }, {
    key: "get",
    value: function get(id) {
      return this._entries.get(id);
    }
  }]);

  return ServiceCollection;
}();